export default "__VITE_ASSET__3e3673a0__"